import styled from 'styled-components';

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: #272643;
  margin-bottom: 2rem;
  margin-top: 5rem;
`;

export const Section = styled.section`
  margin-bottom: 2rem;
`;

export const SubTitle = styled.h2`
  font-size: 1.8rem;
  color: #444;
  margin-bottom: 1rem;
`;

export const Text = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #4D4D4D;
`;

export const BackButton = styled.div`
  margin-top: 2rem;
  
  a {
    display: inline-block;
    padding: 0.5rem 1rem;
    background-color: #2563EB;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    transition: background-color 0.3s;

    &:hover {
      background-color: #1c51c7;
    }
  }
`;
